import { Kaggle } from "@kaggle/sdk";

/** Guard for deep Kernel validation. */
export default function validateKernel(
  kernel: Kaggle.Sdk.Kernels.Models.Kernel
) {
  // The following kernel fields must be present at runtime.
  if (kernel.title === null || kernel.url === null) {
    throw new Error(`Kernel is corrupted: ${JSON.stringify(kernel)}`);
  }

  if (kernel.slug === null) {
    throw new Error(`Kernel should have slug: ${JSON.stringify(kernel)}`);
  }

  if (kernel.author === null || kernel.author.userName === null) {
    throw new Error(`Kernel should have author: ${JSON.stringify(kernel)}`);
  }

  // HACK(cochamberlain): This is required to appease TypeScript.
  return {
    ...kernel,
    title: kernel.title,
    url: kernel.url,
    slug: kernel.slug,
    author: {
      ...kernel.author,
      userName: kernel.author.userName,
    },
  };
}
